export default __webpack_public_path__ + "/assets/edit_big.png";